import React, { useState } from 'react';
import { useWallet } from '../../contexts/WalletContext';
import { CopyableAddress } from './CopyButton';
import { useNavigate } from 'react-router-dom';
import WalletCreator from '../wallet/WalletCreator';
import '../../styles/wallet-selector.css';
import '../../styles/copy-button.css';
import { useTheme } from '../../contexts/ThemeContext';
const WalletSelector = ({ className = '' }) => {
  const { wallets, activeWallet, setActiveWallet } = useWallet();
  const [isOpen, setIsOpen] = useState(false);
  const [showWalletCreator, setShowWalletCreator] = useState(false);
  const navigate = useNavigate();

  const platformWallets = wallets.filter(w => w.wallet_type === 'platform');
  const { theme, toggleTheme, isLight, isDark } = useTheme();

  const handleWalletSelect = (wallet) => {
    setActiveWallet(wallet);
    setIsOpen(false);
  };

  const handleManageWallets = () => {
    setIsOpen(false);
    navigate('/app/wallets');
  };

  const handleCreateWallet = (newWallet) => {
    setShowWalletCreator(false);
    if (newWallet) {
      setActiveWallet(newWallet);
    }
    setIsOpen(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      setIsOpen(false);
    }
  };

  return (
    <>
      <div className={`wallet-selector ${className}`} onClick={handleBackdropClick}>
      <button 
        className="wallet-selector-trigger compact"
        onClick={() => setIsOpen(!isOpen)}
        style={{background:isLight?'white':'black', padding:'5px 13px',
          borderWidth:1, borderColor:'grey'
          }}
      >
        <div className="wallet- compact">
          {activeWallet ? (
            <>
              <div className="wallet-icon compact" style={{
                fontSize:27, background:'', padding:3, 
                borderRadius:'50%', display:'flex', alignItems:'center', 
                justifyContent:'center'
              }}>💼</div>
              {/* <div className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</div> */}
              {/* <div className="wallet-details compact">
                <CopyableAddress 
                  address={activeWallet.wallet_address}
                  truncate={true}
                  truncateLength={3}
                  className="wallet-address-copy compact"
                />
              </div> */}
            </>
          ) : (
            <>
              <div className="wallet-icon compact">⚠️</div>
              <div className="wallet-details compact">
                <span className="wallet-name compact">Connect</span>
              </div>
            </>
          )}
        </div>
        {/* <div className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</div> */}
      </button>

      {isOpen && (
        <div className="wallet-dropdown" onClick={(e) => e.stopPropagation()}>
          <div className="dropdown-header">
            <h4 style={{color: isDark?'white':'black'}}>Select Trading Wallet</h4>
            <button 
              className="close-dropdown"
              onClick={() => setIsOpen(false)}
            >
              ×
            </button>
          </div>

          <div className="wallet-details compact">
                <CopyableAddress 
                  address={activeWallet.wallet_address}
                  truncate={true}
                  truncateLength={3}
                  className="wallet-address-copy compact"
                />
              </div>
          
          <div className="wallet-list">
            {platformWallets.length === 0 ? (
              <div className="no-wallets">
                <div className="no-wallets-icon">💼</div>
                <p>No platform wallets found</p>
                <button 
                  className="create-wallet-btn"
                  // onClick={() => setShowWalletCreator(true)}
                  onClick={handleManageWallets}
                >
                  Create Platform Wallet
                </button>
              </div>
            ) : (
              platformWallets.map(wallet => (
                <div
                  key={wallet.id}
                  className={`wallet-option ${activeWallet?.id === wallet.id ? 'active' : ''}`}
                  onClick={() => handleWalletSelect(wallet)}
                >
                  <div className="wallet-option-icon">💼</div>
                  <div className="wallet-option-details">
                    <span className="wallet-option-name" style={{
                      display:'flex', flexDirection:'row', gap:5
                    }}>
                      {wallet.name || `Wallet ${wallet.id}`}
                      {activeWallet?.id === wallet.id && (
                    <div className="active-indicator">✓</div>
                  )}
                    </span>
                    <span className="wallet-option-address">
                      {wallet.wallet_address.slice(0, 8)}...{wallet.wallet_address.slice(-8)}
                    </span>
                  </div>
                  {/* {activeWallet?.id === wallet.id && (
                    <div className="active-indicator">✓</div>
                  )} */}
                </div>
              ))
            )}
          </div>
          
          <div className="dropdown-footer">
            <button 
              className="manage-wallets-btn"
              onClick={handleManageWallets}
            >
              Manage Wallets
            </button>
          </div>
        </div>
      )}
    </div>

    {showWalletCreator && (
      <div className="modal-overlay" onClick={() => setShowWalletCreator(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <WalletCreator 
            onClose={() => setShowWalletCreator(false)}
            onSuccess={handleCreateWallet}
          />
        </div>
      </div>
    )}
    </>
  );
};

export default WalletSelector;
